var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"600px","background":"black"}},[(_vm.loading)?_c('div',[_vm._v("讀取中...")]):_vm._e(),(_vm.videoOptions.sources.length > 0)?_c('video-player',{attrs:{"options":_vm.videoOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }